import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop error (known browser issue with virtualized lists)
const resizeObserverErr = window.onerror;
window.onerror = function (msg, ...args) {
  if (typeof msg === "string" && msg.includes("ResizeObserver loop")) return true;
  if (resizeObserverErr) return resizeObserverErr.call(this, msg, ...args);
};
window.addEventListener("error", (e) => {
  if (e.message?.includes("ResizeObserver loop")) { e.stopImmediatePropagation(); }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
